// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.screen-area[data-v-aef7bd12] {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgb(128, 128, 128, 0.5);\n}\n.modal-container[data-v-aef7bd12] {\n  border: 1px solid gray;\n  background-color: white;\n  padding: 25px 50px;\n  text-align: center;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.invisible[data-v-aef7bd12] {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
